import { queryOptions, useMutation } from '@tanstack/react-query';
import { axiosDelete, axiosGet, axiosPost, axiosPut } from '../utils/api';

export const getMyCompany = ({ accessToken, params }) =>
  queryOptions({
    queryKey: ['/company/my', params],
    queryFn: async () => {
      const res = await axiosGet('/my-company', { params }, accessToken);
      return res.data;
    },
  });

export const useCreateMyCompany = () =>
  useMutation({
    mutationFn: ({ data }) => {
      return axiosPost('/my-company', data);
    },
  });

export const useUpdateMyCompany = () =>
  useMutation({
    mutationFn: ({ data }) => {
      return axiosPut('/my-company', data);
    },
  });

export const useCreateMyCompanyProduct = () =>
  useMutation({
    mutationFn: ({ data }) => {
      return axiosPost('/my-company/product', data);
    },
  });

export const useUpdateMyCompanyProduct = () =>
  useMutation({
    mutationFn: ({ id, data }) => {
      return axiosPut(`/my-company/product/${id}`, data);
    },
  });

export const useDeleteMyCompanyProduct = () =>
  useMutation({
    mutationFn: ({ id, data }) => {
      return axiosDelete(`/my-company/product/${id}`, data);
    },
  });
